import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Breadcrumb from "components/Common/Breadcrumb";
import { userApiService } from "services/userApiService";

const CreateQwikMedicUser = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    // Required fields
    phonenumber: "",
    password: "1111",
    name: "",
    city: "Dhaka",

    // Optional fields
    nickname: "",
    email: "",
    dateofbath: "",
    gender: "",
    area: "",
    occupation: "",
    postcode: "",
    altphonenumber: "",
    emgphonenumber: "",
    streetaddress: "",
    bloodgroup: "",
    clustername: "",
    insidedhaka: true,
    qmoney: "0",
    qcoins: "0",
    blockstatus: false,
    blockqmoney: false,
    blockreason: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.phonenumber.trim()) {
      newErrors.phonenumber = "Phone number is required";
    } else if (!/^\d{11}$/.test(formData.phonenumber)) {
      newErrors.phonenumber = "Phone number must be 11 digits";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) return;

  //   setSaving(true);
  //   try {
  //     await userApiService.createUser(formData);
  //     toast.success("User created successfully");
  //     navigate("/users");
  //   } catch (error) {
  //     toast.error("Failed to create user");
  //     console.error("Error creating user:", error);
  //   } finally {
  //     setSaving(false);
  //   }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setSaving(true);
    try {
      // First, check if phone number already exists
      const allUsers = await userApiService.getAllUsers();
      const phoneExists = allUsers.some(user =>
        user.phonenumber === formData.phonenumber
      );

      if (phoneExists) {
        toast.error(`Phone number ${formData.phonenumber} already exists`);
        setSaving(false);
        return;
      }

      await userApiService.createUser(formData);
      toast.success("User created successfully");
      navigate("/all-qwik-medic-users");
    } catch (error) {
      // Check if error is about duplicate phone number
      if (error.response?.status === 400 || error.message?.includes("already exists")) {
        toast.error(`Phone number ${formData.phonenumber} already exists`);
      } else {
        toast.error("Failed to create user");
      }
      console.error("Error creating user:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate("/users");
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb
          title="Create User"
          breadcrumbItem="Create New User"
        />

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row mb-4">


                {/* Required Fields */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Name *</label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Full name"
                  />
                  {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Phone Number *</label>
                  <input
                    type="text"
                    name="phonenumber"
                    className={`form-control ${errors.phonenumber ? 'is-invalid' : ''}`}
                    value={formData.phonenumber}
                    onChange={handleChange}
                    placeholder="e.g., 0178xxxxxxx"
                  />
                  {errors.phonenumber && <div className="invalid-feedback">{errors.phonenumber}</div>}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Password *</label>
                  <input
                    type="text"
                    name="password"
                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="User password"
                  />
                  {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                  <small className="form-text text-muted">Default: 1111</small>
                </div>



                <div className="col-md-6 mb-3">
                  <label className="form-label">City *</label>
                  <input
                    type="text"
                    name="city"
                    className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="e.g., Dhaka"
                  />
                  {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                </div>

                {/* Optional Fields */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="email@example.com"
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Nickname</label>
                  <input
                    type="text"
                    name="nickname"
                    className="form-control"
                    value={formData.nickname}
                    onChange={handleChange}
                    placeholder="Nickname"
                  />
                </div> */}

                <div className="col-md-6 mb-3">
                  <label className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    name="dateofbath"
                    className="form-control"
                    value={formData.dateofbath}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Gender</label>
                  <select
                    name="gender"
                    className="form-control"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Area</label>
                  <input
                    type="text"
                    name="area"
                    className="form-control"
                    value={formData.area}
                    onChange={handleChange}
                    placeholder="Area/Location"
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Occupation</label>
                  <input
                    type="text"
                    name="occupation"
                    className="form-control"
                    value={formData.occupation}
                    onChange={handleChange}
                    placeholder="Occupation"
                  />
                </div>

                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Alternative Phone</label>
                  <input
                    type="text"
                    name="altphonenumber"
                    className="form-control"
                    value={formData.altphonenumber}
                    onChange={handleChange}
                    placeholder="Alternative phone"
                  />
                </div> */}

                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Emergency Phone</label>
                  <input
                    type="text"
                    name="emgphonenumber"
                    className="form-control"
                    value={formData.emgphonenumber}
                    onChange={handleChange}
                    placeholder="Emergency contact"
                  />
                </div> */}

                {/* <div className="col-md-12 mb-3">
                  <label className="form-label">Street Address</label>
                  <textarea
                    name="streetaddress"
                    className="form-control"
                    value={formData.streetaddress}
                    onChange={handleChange}
                    rows="2"
                    placeholder="Full street address"
                  />
                </div> */}

                <div className="col-md-6 mb-3">
                  <label className="form-label">Blood Group</label>
                  <select
                    name="bloodgroup"
                    className="form-control"
                    value={formData.bloodgroup}
                    onChange={handleChange}
                  >
                    <option value="">Select Blood Group</option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                </div>

                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Cluster Name</label>
                  <input
                    type="text"
                    name="clustername"
                    className="form-control"
                    value={formData.clustername}
                    onChange={handleChange}
                    placeholder="Cluster name"
                  />
                </div> */}

                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Postcode</label>
                  <input
                    type="text"
                    name="postcode"
                    className="form-control"
                    value={formData.postcode}
                    onChange={handleChange}
                    placeholder="Postal code"
                  />
                </div> */}

                {/* Wallet Fields */}
                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">QMoney</label>
                  <input
                    type="number"
                    name="qmoney"
                    className="form-control"
                    value={formData.qmoney}
                    onChange={handleChange}
                    step="0.01"
                  />
                </div> */}

                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">QCoins</label>
                  <input
                    type="number"
                    name="qcoins"
                    className="form-control"
                    value={formData.qcoins}
                    onChange={handleChange}
                  />
                </div> */}

                {/* Settings */}
                <div className="col-md-6 mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="insidedhaka"
                      name="insidedhaka"
                      className="form-check-input"
                      checked={formData.insidedhaka}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="insidedhaka">
                      Inside Dhaka
                    </label>
                  </div>
                </div>

                {/* <div className="col-md-6 mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="blockstatus"
                      name="blockstatus"
                      className="form-check-input"
                      checked={formData.blockstatus}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="blockstatus">
                      Block User Account
                    </label>
                  </div>
                </div> */}

                {/* <div className="col-md-6 mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="blockqmoney"
                      name="blockqmoney"
                      className="form-check-input"
                      checked={formData.blockqmoney}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="blockqmoney">
                      Block QMoney Usage
                    </label>
                  </div>
                </div> */}

                {/* {formData.blockstatus && (
                  <div className="col-md-12 mb-3">
                    <label className="form-label">Block Reason</label>
                    <textarea
                      name="blockreason"
                      className="form-control"
                      value={formData.blockreason}
                      onChange={handleChange}
                      rows="2"
                      placeholder="Reason for blocking user"
                    />
                  </div>
                )} */}
              </div>

              {/* Form Actions */}
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex gap-2">
                    {/* <button
                      type="button"
                      className="btn btn-light"
                      onClick={handleCancel}
                      disabled={saving}
                    >
                      Cancel
                    </button> */}
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={saving}
                    >
                      {saving ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-plus me-2"></i>
                          Create User
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateQwikMedicUser;